import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const propTypes = {
  theme: PropTypes.string,
};

const defaultProps = {
  theme: '',
};

const Loading = ({ theme }) => (
  <div className="boring-world-loading-container">
    <div className={`boring-world-loading ${theme}`} />
    <div className={`boring-world-loading-message ${theme}`}>Going somewhere...</div>
  </div>
);

Loading.propTypes = propTypes;
Loading.defaultProps = defaultProps;

export default Loading;
